import { useEffect, useState } from "react";
import { api } from "../api";
import { useAuth } from "../AuthContext";

const PLAN_ETIKET = { free: "Ücretsiz", pro: "Pro", max: "Max" };

// Giriş / plan rozeti — sidebar altında, Admin'in üstünde.
function UserPanel() {
  const { isLoggedIn, user, plan, loading, setLoginOpen, signOut, showPricing } = useAuth();
  if (loading) return <div style={{ marginTop:"auto" }} />;

  if (!isLoggedIn) {
    return (
      <div style={{ marginTop:"auto", padding:"10px 12px", borderTop:"1px solid #e9e9e9" }}>
        <button onClick={() => setLoginOpen(true)}
          style={{ width:"100%", padding:"9px 12px", borderRadius:8, border:"none",
                   background:"#2563eb", color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer" }}>
          Giriş yap / Üye ol
        </button>
        <div style={{ fontSize:10.5, color:"#9ca3af", marginTop:6, textAlign:"center" }}>
          Analiz için üyelik gerekir
        </div>
      </div>
    );
  }

  const p = plan?.plan || "free";
  const kalan = plan?.remaining;
  return (
    <div style={{ marginTop:"auto", padding:"10px 12px", borderTop:"1px solid #e9e9e9" }}>
      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:7 }}>
        <div style={{ width:26, height:26, borderRadius:"50%", background:"#e0e7ff", color:"#4338ca",
                      display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, flexShrink:0 }}>
          {(user?.email || "?")[0].toUpperCase()}
        </div>
        <div style={{ minWidth:0, flex:1 }}>
          <div style={{ fontSize:11.5, color:"#374151", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
            {user?.email}
          </div>
          <div style={{ fontSize:10, color:"#9ca3af" }}>
            {PLAN_ETIKET[p] || p}{p === "free" && kalan != null ? ` · ${kalan} analiz kaldı` : p !== "free" ? " · sınırsız" : ""}
          </div>
        </div>
      </div>
      <div style={{ display:"flex", gap:6 }}>
        <button onClick={() => showPricing(null)}
          style={{ flex:1, padding:"6px", borderRadius:6, border:"1px solid #c7d2fe", background:"#eef2ff",
                   color:"#4338ca", fontSize:11, fontWeight:600, cursor:"pointer" }}>
          {p === "free" ? "Yükselt" : "Planım"}
        </button>
        <button onClick={signOut}
          style={{ padding:"6px 10px", borderRadius:6, border:"1px solid #e5e7eb", background:"#fff",
                   color:"#6b7280", fontSize:11, cursor:"pointer" }}>Çıkış</button>
      </div>
    </div>
  );
}

const FLAGS = {
  "Türkiye":"🇹🇷","İngiltere":"🏴󠁧󠁢󠁥󠁮󠁧󠁿","İspanya":"🇪🇸","Almanya":"🇩🇪",
  "İtalya":"🇮🇹","Fransa":"🇫🇷","Hollanda":"🇳🇱","Belçika":"🇧🇪","Portekiz":"🇵🇹","Diğer":"🌍",
};

const PRIORITY = ["Türkiye","İngiltere","İspanya","Almanya","İtalya","Fransa","Hollanda","Belçika","Portekiz","Diğer"];

const AI_CONFIG = {
  claude: { label: "Claude",  icon: "🟠", color: "#d97706", bg: "#fffbeb", border: "#fcd34d", sub: "Anthropic" },
  gpt:    { label: "GPT-4o",  icon: "🟢", color: "#10b981", bg: "#ecfdf5", border: "#6ee7b7", sub: "OpenAI"    },
};

const DEFAULT_KEY = "fa_default_ai";

function AiPanel({ aiProvider, onChangeProvider }) {
  const [open, setOpen] = useState(false);
  const [defaultAi, setDefaultAi] = useState(() => localStorage.getItem(DEFAULT_KEY) || "gpt");
  const cfg = AI_CONFIG[aiProvider];

  const handleSelect = (id) => { onChangeProvider(id); setOpen(false); };
  const handleSetDefault = (id) => {
    localStorage.setItem(DEFAULT_KEY, id);
    setDefaultAi(id);
    onChangeProvider(id);
    setOpen(false);
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Üst ince çizgi */}
      <div style={{ height: 1, background: "#e9e9e9", margin: "0 0" }} />

      {/* Gösterge butonu */}
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", display: "flex", alignItems: "center", gap: 10,
        padding: "10px 16px", background: "transparent",
        border: "none", cursor: "pointer",
      }}>
        <div style={{
          width: 28, height: 28, borderRadius: 6,
          background: cfg.bg, border: `1px solid ${cfg.border}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 13, flexShrink: 0,
        }}>{cfg.icon}</div>
        <div style={{ flex: 1, textAlign: "left" }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>{cfg.label}</div>
          <div style={{ fontSize: 10, color: "#9ca3af" }}>{cfg.sub}</div>
        </div>
        <span style={{ fontSize: 9, color: "#c0c0c0" }}>{open ? "▲" : "▼"}</span>
      </button>

      {/* Alt ince çizgi */}
      <div style={{ height: 1, background: "#e9e9e9", margin: "0 0" }} />

      {/* Dropdown */}
      {open && (
        <div style={{
          position: "absolute", top: "100%", left: 0, right: 0, zIndex: 500,
          background: "#fafafa", borderBottom: "1px solid #e9e9e9",
        }}>
          <div style={{ padding: "8px 16px 4px", fontSize: 10, color: "#b0b0b0",
            letterSpacing: 1, textTransform: "uppercase" }}>AI Motoru</div>
          {Object.entries(AI_CONFIG).map(([id, c]) => {
            const isActive = aiProvider === id;
            const isDef    = defaultAi === id;
            return (
              <div key={id} style={{
                padding: "8px 16px 10px",
                background: isActive ? c.bg : "transparent",
                borderLeft: isActive ? `2px solid ${c.color}` : "2px solid transparent",
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                  <span style={{ fontSize: 12 }}>{c.icon}</span>
                  <span style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>{c.label}</span>
                  {isDef && (
                    <span style={{ fontSize: 9, color: "#9ca3af", background: "#f0f0f0",
                      padding: "1px 5px", borderRadius: 4 }}>default</span>
                  )}
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button onClick={() => handleSelect(id)} style={{
                    flex: 1, padding: "4px 0", borderRadius: 4, fontSize: 10,
                    border: `1px solid ${isActive ? c.border : "#e5e7eb"}`,
                    background: isActive ? c.bg : "#fff",
                    color: isActive ? c.color : "#9ca3af",
                    fontWeight: isActive ? 600 : 400, cursor: "pointer",
                  }}>{isActive ? "✓ Aktif" : "Seç"}</button>
                  <button onClick={() => handleSetDefault(id)} style={{
                    flex: 1, padding: "4px 0", borderRadius: 4, fontSize: 10,
                    border: `1px solid ${isDef ? c.border : "#e5e7eb"}`,
                    background: isDef ? c.bg : "#fff",
                    color: isDef ? c.color : "#9ca3af",
                    fontWeight: isDef ? 600 : 400, cursor: "pointer",
                  }}>{isDef ? "★ Default" : "Set Default"}</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function Sidebar({ selected, onSelect, mode, onModeChange, runningCount, aiProvider, onChangeProvider }) {
  const [groups, setGroups] = useState({});

  useEffect(() => {
    api.leagues().then(d => setGroups(d.groups || {}));
  }, []);

  const ordered = PRIORITY.filter(k => groups[k]).map(k => [k, groups[k]]);

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="s-logo">⚽</div>
        <div className="s-title">FootballAgents</div>
      </div>
      {/* AI Paneli — header ile nav arasında */}
      <AiPanel aiProvider={aiProvider} onChangeProvider={onChangeProvider} />

      <div className="s-nav">
        <button
          className={mode === "home" ? "s-nav-item active" : "s-nav-item"}
          onClick={() => onModeChange("home")}
        >🏠 Ana Sayfa</button>
        <button
          className={mode === "stats" ? "s-nav-item active" : "s-nav-item"}
          onClick={() => onModeChange("stats")}
        >📈 İstatistikler</button>
        <button
          className={mode === "predict" ? "s-nav-item active" : "s-nav-item"}
          onClick={() => onModeChange("predict")}
          style={{position:"relative"}}
        >
          🎯 Tahmin
          {runningCount > 0 && (
            <span style={{
              marginLeft:6, fontSize:10, background:"#f59e0b", color:"#fff",
              borderRadius:10, padding:"1px 6px", fontWeight:700,
            }}>{runningCount}</span>
          )}
        </button>
        <button
          className={mode === "history" ? "s-nav-item active" : "s-nav-item"}
          onClick={() => onModeChange("history")}
        >📊 Geçmiş</button>
        <button
          className={mode === "help" ? "s-nav-item active" : "s-nav-item"}
          onClick={() => onModeChange("help")}
        >❓ Yardım</button>
      </div>

      <div className="s-leagues">
        <div className="s-country">⚽ Ligler</div>

        {ordered.map(([country, leagues], ci) => (
          <div key={country}>
            <div className="s-country">{FLAGS[country]} {country}</div>
            {leagues.map((lg, li) => {
              const isActive = selected === lg && mode === "league";
              const isDiger  = country === "Diğer";
              if (li === 0 && !isDiger) {
                // Normal grupta ilk lig → ana stil
                return (
                  <button
                    key={lg}
                    className={isActive ? "s-league active" : "s-league"}
                    onClick={() => onSelect(lg)}
                  >{lg}</button>
                );
              } else if (isDiger) {
                // Diğer grubundaki tüm ligler → küçük, soluk, girintili
                return (
                  <button
                    key={lg}
                    className={isActive ? "s-sub active" : "s-sub"}
                    onClick={() => onSelect(lg)}
                    style={{
                      paddingLeft: 28,
                      fontSize: 11,
                      color: isActive ? undefined : "#9ca3af",
                      fontWeight: isActive ? 600 : 400,
                    }}
                  >{lg}</button>
                );
              } else {
                // Normal grupta ikinci/üçüncü lig → sub stil
                return (
                  <button
                    key={lg}
                    className={isActive ? "s-sub active" : "s-sub"}
                    onClick={() => onSelect(lg)}
                  >{lg}</button>
                );
              }
            })}
            {ci < ordered.length - 1 && <div className="s-div" />}
          </div>
        ))}
      </div>
      {/* Kullanıcı / üyelik */}
      <UserPanel />

      {/* Admin butonu — en alt */}
      <div style={{ padding:"8px 12px", borderTop:"1px solid #e9e9e9" }}>
        <button
          onClick={() => onModeChange("admin")}
          style={{
            width:"100%", padding:"7px 12px", borderRadius:6, border:"1px solid #e5e7eb",
            background: mode === "admin" ? "#f1f5f9" : "transparent",
            color:"#9ca3af", fontSize:11, cursor:"pointer", textAlign:"left",
            display:"flex", alignItems:"center", gap:6,
          }}
        >
          <span>🔧</span> <span>Admin</span>
        </button>
      </div>
    </aside>
  );
}
